import React from "react";

export const Award2Icon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.9969 40.4705C25.9513 40.4706 22.9829 39.3915 20.6208 37.3815C17.7068 34.9017 16.0354 31.2854 16.0354 27.4602V23.888C16.0354 23.4751 16.1965 23.0868 16.4888 22.7952C16.7801 22.5047 17.167 22.3447 17.5783 22.3447C17.5796 22.3447 17.581 22.3447 17.5824 22.3447L26.935 22.3652C27.5184 22.3665 27.9904 22.8405 27.9891 23.424C27.9878 24.0065 27.515 24.4781 26.9328 24.4781C26.932 24.4781 26.9312 24.4781 26.9304 24.4781L18.1483 24.4588L18.1481 27.4601C18.1481 30.6647 19.5484 33.6944 21.9899 35.7721C24.4127 37.8339 27.5978 38.7257 30.7269 38.218C30.8355 38.2004 30.9447 38.1819 31.055 38.1627C31.6304 38.063 32.1772 38.4464 32.2779 39.021C32.3785 39.5958 31.9942 40.1432 31.4195 40.2438C31.3005 40.2646 31.1822 40.2847 31.065 40.3037C30.3761 40.4155 29.6843 40.4705 28.9969 40.4705Z"
      fill="#FFB125"
    />
    <path
      d="M41.0029 40.4704C40.3152 40.4704 39.624 40.4154 38.9347 40.3037C38.8175 40.2847 38.6992 40.2646 38.5801 40.2438C38.0054 40.1432 37.6212 39.5956 37.7218 39.021C37.8224 38.4462 38.3706 38.0627 38.9446 38.1627C39.0548 38.1821 39.1642 38.2005 39.2728 38.218C42.4025 38.7253 45.587 37.8339 48.0098 35.7722C50.4513 33.6946 51.8516 30.6649 51.8516 27.4601V24.4588L43.0694 24.4781C43.0686 24.4781 43.0678 24.4781 43.067 24.4781C42.4847 24.4781 42.0119 24.0067 42.0107 23.424C42.0093 22.8405 42.4813 22.3665 43.0648 22.3652L52.4179 22.3447C52.4192 22.3447 52.4206 22.3447 52.422 22.3447C52.8329 22.3447 53.2197 22.5046 53.5112 22.7952C53.8035 23.087 53.9646 23.475 53.9646 23.888V27.4602C53.9646 31.2854 52.2933 34.9017 49.3791 37.3815C47.0171 39.3912 44.0483 40.4704 41.0029 40.4704Z"
      fill="#FFB125"
    />
    <path
      d="M28.0542 55.7802H41.9461C36.1917 48.483 36.7922 37.9663 36.7922 37.9663H35.0002H33.2082C33.2082 37.9664 33.8087 48.4831 28.0542 55.7802Z"
      fill="#FED130"
    />
    <path
      d="M36.7921 37.9666H35.0001H33.2081C33.2081 37.9666 33.3011 39.5994 33.062 42.0245C32.6061 46.6471 33.7528 51.3103 36.4582 55.0861C36.6261 55.3204 36.8 55.552 36.9801 55.7803H41.9461C36.1916 48.4832 36.7921 37.9666 36.7921 37.9666Z"
      fill="#F7BC14"
    />
    <path
      d="M24.5208 19.3174V28.5337C24.5208 33.9863 27.1123 39.1144 31.5022 42.3486C33.5822 43.881 36.4175 43.881 38.4975 42.3486C42.8874 39.1145 45.4789 33.9863 45.4789 28.5337V19.3174H24.5208Z"
      fill="#FED130"
    />
    <path
      d="M40.4895 19.3174V28.5337C40.4895 33.9864 37.898 39.1144 33.5081 42.3486C33.1897 42.5832 32.8535 42.7815 32.5051 42.9442C34.4326 43.8447 36.7359 43.6465 38.4975 42.3486C42.8874 39.1145 45.4789 33.9864 45.4789 28.5337V19.3174H40.4895Z"
      fill="#F7BC14"
    />
    <path
      d="M46.23 20.757H23.7704C23.4319 20.757 23.1575 20.4826 23.1575 20.1441V17.6041C23.1575 17.2656 23.4319 16.9912 23.7704 16.9912H46.23C46.5685 16.9912 46.8429 17.2656 46.8429 17.6041V20.1441C46.8428 20.4826 46.5684 20.757 46.23 20.757Z"
      fill="#FFB125"
    />
    <path
      d="M46.3766 17H42V20.7656H46.3766C46.7152 20.7656 46.9894 20.4912 46.9894 20.1527V17.6128C46.9894 17.2744 46.715 17 46.3766 17Z"
      fill="#FF901D"
    />
    <path
      d="M46.917 60.234H23.1772C22.8331 60.234 22.5942 59.8912 22.7134 59.5684L24.4764 54.7915C24.5481 54.5972 24.7332 54.4683 24.9402 54.4683H45.154C45.361 54.4683 45.5461 54.5972 45.6178 54.7915L47.3808 59.5684C47.5 59.8912 47.2611 60.234 46.917 60.234Z"
      fill="#FFB125"
    />
    <path
      d="M47.3809 59.5684L45.6179 54.7915C45.5462 54.5972 45.3612 54.4683 45.154 54.4683H40.3325L42.4604 60.234H46.917C47.2612 60.234 47.5 59.8912 47.3809 59.5684Z"
      fill="#FF901D"
    />
  </svg>
);
